import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import StatusDia from './StatusDia';
import { NotificationsRounded } from '@mui/icons-material';
import { Badge } from '@mui/material';

function CuadroInformativo(props) {
  const solicitudes = props.datos;

  React.useEffect(() => {
    solicitudes
  }, [solicitudes])

  return (
    <Fragment>
      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style={{ textAlign: 'center', fontSize: '14px' }}>
        <br />
        {/* {
          solicitudes.length > 0 ?
            <Badge badgeContent={solicitudes.length} color="error">
              <NotificationsRounded />
            </Badge>
            :
            <Badge badgeContent={0} color="error">
              <NotificationsRounded />
            </Badge>
        } */}

      </div>
    </Fragment>
  );
};


export default withRouter(CuadroInformativo)